module.exports = __webpack_public_path__ + "img/info-4.2bc42a66.png";